module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAABNElEQVR4Aa2UNVY1URCE+1c0goiMFeG6Hdw38FJcdoDmz90iHCIkw/vDZe54ndNjXfXd02NipcfHx3/pdLpXayGVSpV0f01xzDV6eMSNMplMpwaqGn60Kzx4jSBd8bcapjB7KTJkfwBdwWygP8akEaRgfH4A1aBAGLCEJ2ZjOtD9YD6fb6E45pqNvxfgggmWy+Wa5Ju4ZoLCEt4tw4qDYhA9Q6YkvLBWTUY0AelZZWABvAoReAkwFtbIsAAOh/hQhqVQKLTqyW0Ir80trLcvJRLClxKRNym5WS+eBwCewZDP0lE6fH5yD1rtYiGg4z6A47b/RDVteABukBE7VSqVGl111wmGB6+4EO9aowb2bGB7eMSLjo+P6zW8ZQHcoif2sh1/9Q3Gsdsx7R7ULwXNURyLg54Ap0RjUqYWjzIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/wz.png
// module id = GXwa
// module chunks = 1